import { render, staticRenderFns } from "./CustomizeFieldsWithBtn.vue?vue&type=template&id=92a01890&scoped=true&"
import script from "./CustomizeFieldsWithBtn.vue?vue&type=script&lang=js&"
export * from "./CustomizeFieldsWithBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a01890",
  null
  
)

export default component.exports